<h2 mat-dialog-title>{{title}}</h2>
@let ds = accountsDataSource;
<mat-dialog-content>
  @if (busyLoadingAccounts) {
    <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
  }
  <mat-tab-group class="w-100" [style.height.px]="600" (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Accounts" class="w-100">
      @if(ds){
        <table mat-table [dataSource]="ds ?? []" matSort (matSortChange)="accountSortChange($event)">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Name</b></th>
            <td mat-cell *matCellDef="let account" [appHighlight]="[accountsFilterValue,account.name]">{{account.name}}</td>
          </ng-container>
          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Code</b></th>
            <td mat-cell *matCellDef="let account" [appHighlight]="[accountsFilterValue,account.code]">{{account.code}}</td>
          </ng-container>
          <ng-container matColumnDef="class">
            <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Class</b></th>
            <td mat-cell *matCellDef="let account" [appHighlight]="[accountsFilterValue,account.accountClass]">{{account.accountClass}}</td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Type</b></th>
            <td mat-cell *matCellDef="let account" [appHighlight]="[accountsFilterValue,account.accountType]">{{account.accountType}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedAccountColumns"></tr>
          <tr mat-row *matRowDef="let account; columns: displayedAccountColumns;"></tr>
        </table>
      }
      <mat-divider class="w-100"></mat-divider>
    </mat-tab>
    <mat-tab label="Tracking Categories & Options">
      @if (busyLoadingTrackingCategories) {
        <app-mat-spinner-overlay  [overlay]="true"></app-mat-spinner-overlay>
      }
      @if (trackingCategoriesDataSource) {
        <mat-tree #tree [dataSource]="trackingCategoriesDataSource" [childrenAccessor]="childrenAccessor">
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
            <!-- use a disabled button to provide padding for tree leaf -->
            <button mat-icon-button disabled></button>
            {{node.name}}
          </mat-tree-node>
          <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror">{{tree.isExpanded(node) ? 'expand_more' : 'chevron_right'}}</mat-icon>
            </button>
            {{node.name}}
          </mat-tree-node>
        </mat-tree>
      }
      @if (trackingCategoriesDataSource?.length==0) {
        <div class="flex-col justify-stretch items-center"><span class="mt-5">No tracking categories exist in Xero</span></div>
      }
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="w-100 flex-row space-between items-center mt-3 mx-3">
    @if (currentTabIndex==0 && ds && ds.data!.length>0) {
      <mat-form-field appearance="fill">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyAccountsFilter($event)" placeholder="Search Columns" [value]="accountsFilterValue" />
      </mat-form-field>
    }
    @else{<span></span>}
    <a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()" tabindex="-1"><span class="text-bold">{{confirmButtonText}}</span></a>
  </div>
</mat-dialog-actions>
